export enum DefaultClientIPListIcons {
  PROGRAM_ENROLLMENT = 'book-outline',
  INDIVIDUAL_PLAN = 'map-outline',
  GOAL = 'clipboard-outline',
  STEP = 'footsteps-outline',
}
